import { FC } from 'react';

import { css } from 'styled-components';

import ArrowLeft from '@crehana/icons/outline/ArrowLeft';
import TextLink from '@crehana/ui/dist/Buttons/TextLink';

interface ArrowBackProps {
  backStep: () => void;
}

const ArrowBack: FC<React.PropsWithChildren<ArrowBackProps>> = ({
  backStep,
}) => {
  return (
    <TextLink
      label="Volver"
      leftIcon={{
        component: ArrowLeft,
        size: 24,
      }}
      type="level1"
      onClick={backStep}
      css={css`
        top: -50px;
      `}
      className="absolute text-secondary-main"
    />
  );
};

export default ArrowBack;
